var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{key:_vm.clients.length,staticClass:"alt-shading",staticStyle:{"cursor":"pointer"},attrs:{"headers":_vm.headers,"items":_vm.clients},on:{"click:row":(item) => _vm.goToClient(item)}})
}
var staticRenderFns = []

export { render, staticRenderFns }